import { CheckboxController } from '@avanta/shared/components/ui/Checkbox';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useState } from 'react';
import { type FieldValues, type Control, type RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const legalDocumentLinks = [
  {
    href: 'https://www.avantamynd.com/RGPD-Mynd-2026-ADULTOS-PAE.pdf',
    label: 'SignupForm.legalDocuments.adultsPae',
  },
  {
    href: 'https://www.avantamynd.com/RGPD-Mynd-2026-ADULTOS.pdf',
    label: 'SignupForm.legalDocuments.adults',
  },
  {
    href: 'https://www.avantamynd.com/RGPD-Mynd-2026-INFANTIL.pdf',
    label: 'SignupForm.legalDocuments.child',
  },
] as const;

type TermsAcceptedCheckboxProps = {
  control: Control<FieldValues>;
  name: string;
  className?: string;
  rules?: RegisterOptions;
};

export const TermsAcceptedCheckbox = ({
  className,
  control,
  name,
}: TermsAcceptedCheckboxProps): React.ReactElement => {
  const [showLegalDocuments, setShowLegalDocuments] = useState(false);
  const { t } = useTranslation(LOCIZE_NS.AUTH);

  const termsAcceptedLabelTemplate = t('SignupForm.termsAcceptedLabel', { ns: LOCIZE_NS.AUTH });
  const [termsAcceptedLabelPrefix, termsAcceptedLabelSuffix = ''] =
    termsAcceptedLabelTemplate.split('{{termsLink}}');

  const toggleLegalDocuments = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setShowLegalDocuments(previousValue => !previousValue);
  };

  return (
    <div className={cn('flex gap-2')}>
      <CheckboxController name={name} control={control} className={className} />
      <span className="font-normal text-sm text-gray-700">
        <span>{termsAcceptedLabelPrefix}</span>
        <button
          type="button"
          className=" text-teal-600 hover:text-teal-500 hover:underline"
          onClick={toggleLegalDocuments}
        >
          {t('SignupForm.termsAcceptedLinkLabel')}
        </button>
        <span>{termsAcceptedLabelSuffix}</span>
        {showLegalDocuments && (
          <ul className="mt-2 list-disc pl-5 space-y-1">
            {legalDocumentLinks.map(document => (
              <li key={document.href}>
                <a
                  href={document.href}
                  target="_blank"
                  rel="noreferrer"
                  className="underline text-denim-800 hover:text-denim-300 "
                  onClick={event => event.stopPropagation()}
                >
                  {t(document.label)}
                </a>
              </li>
            ))}
          </ul>
        )}
      </span>
    </div>
  );
};
